import React from "react";

type IconProps = { isSelected: boolean; isHovered: boolean };

const RectangulaireBandeauIcon: React.FC<IconProps> = ({ isSelected, isHovered }) => (
  <svg viewBox="0 0 120 80" className="w-full h-full">
    <rect
      x="15"
      y="20"
      width="90"
      height="40"
      rx="6"
      fill={isSelected ? "#3B82F6" : isHovered ? "#E5E7EB" : "#F3F4F6"}
      stroke={isSelected ? "#1E3A8A" : "#9CA3AF"}
      strokeWidth="2"
    />
    <rect
      x="20"
      y="25"
      width="80"
      height="30"
      rx="4"
      fill={isSelected ? "#60A5FA" : isHovered ? "#F9FAFB" : "#FFFFFF"}
      stroke={isSelected ? "#1E3A8A" : "#D1D5DB"}
      strokeWidth="1"
    />
  </svg>
);

const RectangleSimpleIcon: React.FC<IconProps> = ({ isSelected, isHovered }) => (
  <svg viewBox="0 0 120 80" className="w-full h-full">
    <rect
      x="18"
      y="22"
      width="84"
      height="36"
      rx="2"
      fill={isSelected ? "#22C55E" : isHovered ? "#E5E7EB" : "#F3F4F6"}
      stroke={isSelected ? "#15803D" : "#9CA3AF"}
      strokeWidth="2"
      strokeDasharray="6 4"
    />
  </svg>
);

const IconMap: Record<string, React.FC<IconProps>> = {
  rectangulaire_bandeau: RectangulaireBandeauIcon,
  rectangle_simple: RectangleSimpleIcon,
};

export interface ShapePickerIconProps {
  id: string;
  label: string;
  selectedId?: string;
  onSelect: (id: string) => void;
}

export const ShapePickerIcon: React.FC<ShapePickerIconProps> = ({ id, label, selectedId, onSelect }) => {
  const [hover, setHover] = React.useState(false);
  const Icon = IconMap[id] || RectangulaireBandeauIcon;
  const isSelected = selectedId === id;
  return (
    <button
      type="button"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onSelect(id)}
      className={`flex flex-col items-center gap-2 p-3 border rounded-lg transition shadow-sm ${
        isSelected ? "border-blue-600 ring-2 ring-blue-200" : "border-gray-200 hover:border-gray-300"
      }`}
    >
      <div className="w-24 h-16">
        <Icon isSelected={isSelected} isHovered={hover} />
      </div>
      <span className="text-sm font-medium text-gray-800 text-center">{label}</span>
    </button>
  );
};
